
export default {
  name: 'Overview',
  data() {
    return {
      overview: '',
      expandOverview: false,
    }
  },
  computed: {
    formattedOverview() {
      if (this.overview && this.overview.length >= 400) {
        return this.overview.slice(0, 400).trim() + "..."
      }
    }
  },
  methods: {
    setOverviewVariable() {
      const media = this.$store.state.media.media
      if (media.info.overview) {
        this.overview = media.info.overview
      }
      if (media.info.biography) {
        this.overview = media.info.biography
      }
      return ''
    }
  },
  created() {
    this.setOverviewVariable()
  }
}
